module.exports = __webpack_public_path__ + "img/jekyll_logo.eaa247fe.svg";